/** Backend routes (see nodeapp/README.md). vwappservices concatenates these onto the base URL. */
export const API = {
  AUTH: {
    LOGIN: '/auth/login',
    REFRESH: '/auth/refresh',
    LOGOUT: '/auth/logout',
    SESSION: '/auth/getSession',
  },
  APPS: {
    MY_APPS: '/apps/myApps',
  },
  SSO: {
    AUTHORIZE: '/sso/authorize',
  },
  USERS: {
    OPTIONS: '/users/options',
    LIST: '/users/list',
    GET: '/users/get',
    CREATE: '/users/create',
    UPDATE: '/users/update',
    SET_ACTIVE: '/users/setActive',
    RESET_PASSWORD: '/users/resetPassword',
    SYNC_APPS: '/users/syncApps',
  },
} as const;
